import React, { useState } from 'react';

import { Row, Col, Layout, Divider, Modal, Image, Typography } from 'antd';
import Login from './Login';
import Logo from "../../Components/Graphics/Logo";
const { Content } = Layout;


const EntryPortal = ({initialView, prospect}) => {
    const [view, setView] = useState(initialView || 'portal'); // Initial view set to 'title'
    const [isProspect, setIsProspect] = useState(prospect || false);

    const handleLogin = (prospectState) => {
        setIsProspect(prospectState);
        setView('login');
    };


    return (
        <Layout style={{background:"var(--light-grey)", height:'100vh'}}>
            {view === 'portal' && (
                <>
                    <Content style={{background: 'var(--light-grey)', padding: '30px'}}>
                        <Row justify={'center'}>
                            <Logo src={'https://storage.googleapis.com/finiat-web-static-resources/company-brands/id-lookup/finiat.png'}
                                  height={'150px'}
                                  width={'150px'}
                            />
                        </Row>
                        <Row justify={'center'} align={'top'} gutter={96} style={{marginTop: 100}}>
                            <Col>
                                <Typography.Title level={5} style={{fontFamily: "Comfortaa, sans-serif"}}>IA Platform Login</Typography.Title>
                                <div class={'shadow-sm p-3 mb-2'} onClick={()=>handleLogin(false)}>
                                    <Image src={'https://storage.googleapis.com/finiat-web-static-resources/homepage/homescreen.png'}
                                           height={150}
                                           width={260}
                                           preview={{mask: <div className="custom-mask">Login to IA Platform</div>}}
                                    />
                                </div>
                                <Typography.Link style={{marginTop:10}}>Forgot Password?</Typography.Link>
                            </Col>
                        </Row>
                </Content>
                </>
            )}
            {view === 'login' && (
                <Login isProspect={isProspect} onBack={() => setView('portal')} />
            )}
        </Layout>
    );
};

export default EntryPortal;
